import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { RevelType } from '@/interfaces/models/RevelType';
import { RevelSyncMode } from '@/enums/RevelSyncMode';

export default class RevelApiService extends ApiService<any> {
  constructor() {
    super('revel');
  }

  public getTypes(venueId: string): AxiosPromise<RevelType[]> {
    return axios.get(`${this.getBaseUrl()}/custom-order-options`, { params: { venue: venueId } });
  }

  public syncMenu(payload: { venue: string; mode: RevelSyncMode }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/menu/sync`, {
      mode: payload.mode,
      venue: payload.venue,
    });
  }
}
